<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
        <CForm>
            <CRow>
              <CCol md="2">
                <CInput
                  label="Código:"
                  :lazy="false"
                  :value.sync="$v.form.code.$model"
                  :isValid="checkIfValid('code')"
                  placeholder=""
                  autocomplete="given-code"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="8">
                <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="2">
                <CSelect
                  label="Tipo"
                  id="type"
                  name="type"
                  :value.sync="$v.form.type.$model"
                  :options="typeOptions"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CSelect
                  label="Vendedor"
                  id="supplier_id"
                  name="supplier_id"
                  :lazy="false"
                  :value.sync="$v.form.supplier_id.$model"
                  :isValid="checkIfValid('supplier_id')"
                  :options="suppliersOptions"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"
import ws from '../../services/customers';
import suppliers_ws from '../../services/suppliers';

export default {
  name: 'CustomerModal',
  props: {

  },
  data () {
    return {
      showModal: false,
      title: "Nuevo Cliente",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ],
      suppliers: [],
      suppliersOptions: [],
      typeOptions: [
        {label: 'Detalle', value: 'detalle'},
        {label: 'Top', value: 'top'},
        {label: 'General', value: 'general'}
      ],
    }
  },
  mounted: async function() {
    let response = await suppliers_ws.get(); 

    if(response.type == "success"){
      this.suppliers = response.data;
      this.suppliersOptions = await this.$parseSelectOptionsOrdered(this.suppliers, "id", "code:name", [{value: '', label: ''}]);
    }
  },
  methods: {
    storeModal () { 
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Cliente';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
          id: 0,
          code: '',
          name: '',
          supplier_id: '',
          type: 'general'
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Cliente';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          code: item.code,
          name: item.name,
          supplier_id: item.supplier_id,
          type: item.type
      };
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          code: '',
          name: '',
          supplier_id: '',
          type: 'general'
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      code: {
        required,
        minLength: minLength(3)
      },
      supplier_id: {
        required
      },
      type: {
        required
      }
    }
  },
}
</script>